import React from 'react';

import './StyleLoading.css';

import { Button, Spinner } from 'react-bootstrap';

export default (props) => {
  if(!props['title']){
    return(  <div className="Loading">
    <div className="loading-box">
      <Spinner className="loading-img" animation="border" />
      <div className="loading-txt">Loading</div>
    </div>
  </div>
  )  
  } 
  else if(props['mode'] == 'displayText'){
    return(
    <div onClick={props['closeModal']} className="Loading">
      <div className="loading-box">
        <div className="loading-txt"><br/>{`ใบอนุญาตเลขที่ ${props['licenseID'].slice(6,props['licenseID'].length)} เป็นของ`} <p style={{color:'red'}}>บริษัท {props['companyName']}</p></div>
      </div>
    </div>
    )  
  }
  else if(props['mode'] == 'warningText'){
    return(
    <div className="Loading">
      <div className="loading-box">
        <div className="loading-txt">
          <br/>ยืนยันที่จะลบทะเบียนเลขที่ <br/> 
          <p style={{color:'red',fontSize:'24px'}}>{`${props['requestID']}`.split('-')[5]}
          <br/>
          <Button onClick={props['closeModal']} variant='dark'>ยกเลิก</Button>

          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <Button onClick={props['handleRemoveRequestID']}>ยืนยัน</Button>
          <br/>
          <br/>
          <br/>

          
          </p> 
          <br/>

          </div>
      </div>
    </div>
    )  
  }
  else{
    return(  <div className="Loading">
    <div className="loading-box">
      <Spinner className="loading-img" animation="border" />
      <div className="loading-txt">{props['title']}</div>
    </div>
  </div>
  )  
  }
}
